import React, {useState} from 'react';
import './header.scss';

const Header = ({logo, headerFixed}) => {

    const [openMenu, setOpenMenu] = useState(false);

    const headerStyles = (style) => headerFixed ? `${style} fixed` : `${style}`;

    const mainHeader = 
        <header className={headerStyles('App-header')}>
            <ul>
                <li><a href="#entradas">Entradas</a></li>
                <li><a href="#visita">Visítanos</a></li>
                <li><a href="#animales">Animales</a></li>
                <li><a href="#top"><img className="logo" src={logo} alt="triassic park logo" /></a></li>
                <li className='animate-container'><a className='animate' href="#eventos">Eventos</a></li>
                <li><a href="#equipo">Equipo</a></li>
                <li><a href="#ofertas">¡OFERTAS!</a></li>
            </ul>
        </header>
    ;

    const mobileHeader = 
        <header className={headerStyles('mobile-header')}>
            <a href="#top" ><img onClick={() => setOpenMenu(false)} className="logo" src={logo} alt="triassic park logo" /></a>
            <button className="menu-open" onClick={() => setOpenMenu(true)} aria-label="Open menu" type="button"/>
            <ul style={{display: openMenu ? 'block' : 'none'}}>
                <li className='close'>
                    <button className="menu-close" onClick={() => setOpenMenu(false)} aria-label="Close menu" type="button"/>
                </li>
                <li onClick={() => setOpenMenu(false)}><a href="#entradas">Entradas</a></li>
                <li onClick={() => setOpenMenu(false)}><a href="#visita">Visítanos</a></li>
                <li onClick={() => setOpenMenu(false)}><a href="#animales">Animales</a></li>
                <li onClick={() => setOpenMenu(false)} className='animate-container'><a className='animate' href="#eventos">Eventos</a></li>
                <li onClick={() => setOpenMenu(false)}><a href="#equipo">Equipo</a></li>
                <li onClick={() => setOpenMenu(false)}><a href="#ofertas">¡OFERTAS!</a></li>
            </ul>
        </header>
    ;

    return (
        <>
            {mobileHeader}
            {mainHeader}
        </>
    );
}

export default Header;